import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import elementsIds from '@/const/elementIds.json';
import { useOsService } from '@/services/OsService/OsService';
import AgentTableFiltersWindows from './components/AgentTableFilters-list/OS/AgentTableFilters.windows.vue';
import AgentTableFiltersLinux from './components/AgentTableFilters-list/OS/AgentTableFilters.linux.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentTableFilters',
  setup(__props) {

const osService = useOsService();

return (_ctx: any,_cache: any) => {
  return (_unref(osService)?.isWindows.value)
    ? (_openBlock(), _createBlock(AgentTableFiltersWindows, {
        key: 0,
        "data-testid": _unref(elementsIds).agentsTableFilters.listWindows
      }, null, 8, ["data-testid"]))
    : (_unref(osService)?.isUnix.value)
      ? (_openBlock(), _createBlock(AgentTableFiltersLinux, {
          key: 1,
          "data-testid": _unref(elementsIds).agentsTableFilters.listLinux
        }, null, 8, ["data-testid"]))
      : _createCommentVNode("", true)
}
}

})